import DataTableView from "@components/views/datatable-view";
import LoadingButton from "@components/ui-components/loading-button";
import usePageChange from "@hooks/use-page-change";
import usePlaybooks from "./use-playbooks";
import UpsertPlaybooks from "./upsert";

const Playbooks = () => {
    const {
        data: { playbooks = [], pagination = {} },
        loading,
        columns,
        setQueryParams,
        handleModalConfig,
        modalConfig,
        getPlaybooks
    } = usePlaybooks();

    /* A custom hook that is used to handle the pagination. */
    const { handlePageChange, handlePerRowsChange } = usePageChange({
        setQueryParams
    });
    return (
        <>
            <DataTableView
                moduleName={"Playbooks"}
                breadcrumbItems={{
                    items: [
                        {
                            title : "Playbooks",
                            active: true
                        }
                    ]
                }}
                loading={loading}
                tableProps={{
                    data: playbooks,
                    columns,
                    handlePageChange,
                    handlePerRowsChange,
                    pagination
                }}
                actionItems={
                    <LoadingButton
                        color="primary"
                        icon="plus"
                        onClick={() => handleModalConfig({})}
                        subject="playbooks"
                        text="Add Playbooks"/>
                }/>
            <UpsertPlaybooks
                getPlaybooks={getPlaybooks}
                modalConfig={modalConfig}
                handleModal={handleModalConfig}/>
        </>
    );
};

export default Playbooks;
